<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.57617 7.07064C5.57617 3.23244 8.65585 0.120972 12.4548 0.120972C16.2538 0.120972 19.3335 3.23244 19.3335 7.07064C19.3335 10.9088 16.2538 14.0203 12.4548 14.0203C8.65585 14.0203 5.57617 10.9088 5.57617 7.07064Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.92386 17.515C6.78675 16.6716 9.27158 16.3976 12.4549 16.3976C15.6317 16.3976 18.1127 16.6705 19.974 17.5096C21.9718 18.4102 23.198 19.9403 23.8517 22.1658C24.0945 22.9929 23.5202 23.8265 22.7261 23.8265H2.17658C1.3858 23.8265 0.814833 22.9966 1.05571 22.1741C1.70743 19.9487 2.92933 18.418 4.92386 17.515Z"
      fill="currentColor"
    />
  </svg>
</template>
